import cc from 'classcat';
import { capitalizeFirst } from 'ramda-extension';

import { H2 } from './Headings';
import styles from './HeaderText.scss';

export function HeaderText({ value, variant, ...props }) {
  return (
    <H2
      className={cc([
        styles.headerText,
        styles[`variant${capitalizeFirst(variant)}`],
      ])}
    >
      {value}
    </H2>
  );
}
